import ErrorIcon from '@mui/icons-material/Error';
import { CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { trainingAdminRequests } from 'redux/requests/training-admin.routes';
import { useApiCall } from 'redux/utils/api-hook';
import { Button, FlexContainer } from '@act/storybook';

const TrainingProviderStatus = () => {
  const [
    providerStatus,
    isGettingProviderStatus,
    getProviderStatus,
    getProviderStatusErrorResponse,
  ] = useApiCall(trainingAdminRequests.getTrainingProviderStatus);

  const [
    updatedProviderStatus,
    isUpdatingProviderStatus,
    setProviderStatus,
    setProviderStatusErrorResponse,
  ] = useApiCall(trainingAdminRequests.setTrainingProviderStatus);

  useEffect(() => {
    void getProviderStatus({ params: null });
  }, []);

  let errorMessage: string;
  if (getProviderStatusErrorResponse) {
    errorMessage =
      'An error occurred while getting the provider status for the training client';
  } else if (setProviderStatusErrorResponse) {
    errorMessage =
      'An error occurred while updating the provider status for the training client';
  }

  const isLoading = isGettingProviderStatus || isUpdatingProviderStatus;

  const isProviderClient = updatedProviderStatus
    ? updatedProviderStatus.isProviderClient
    : providerStatus?.isProviderClient;

  return (
    <FlexContainer direction="column" gap={1} height="fit-content">
      <Typography variant="titleLarge">
        Training Client Provider Status
      </Typography>
      {isLoading && <CircularProgress />}

      {errorMessage && (
        <div>
          <ErrorIcon /> {errorMessage}
        </div>
      )}

      {!isLoading && !errorMessage && (
        <div>
          <p>
            {isProviderClient
              ? 'Training client is currently set to be a behavioral health client that uses Avon'
              : 'Training client is currently set up to be a community guide only client.'}
          </p>
          <div>
            <Button
              variant="contained"
              onClick={() => {
                void setProviderStatus({
                  body: { isProviderClient: !isProviderClient },
                  params: null,
                });
              }}
              debounced
            >
              {isProviderClient
                ? 'Make training client Community Guide only'
                : 'Make training client a behavioral health client'}
            </Button>
          </div>
        </div>
      )}
    </FlexContainer>
  );
};

export default TrainingProviderStatus;
